import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import moment from "moment-timezone";
export default {
    namespaced: true,
    state: {
        historydata:[],
    },
    mutations: {
        setHistory(state:any, result:any) {
            state.historydata = result
        },
    },
    actions: {
        getData({ commit, rootState, state, dispatch }: any, userId){
            firebase.firestore().collection('history').where('userId', '==', userId).get().then(function (querySnapshot) {
                const history: Array<any> = [];
                querySnapshot.forEach(function (doc) {
                    const data = doc.data();
                    data.key = doc.id;
                    data.createdateShow = moment(data.createdate,'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY');
                    history.push(data);
                });
                commit('setHistory', history)
            });
        }
    },
    getters: {
        historydata: ({historydata}) => {
            return historydata
        }
    }
}